<div class="our-team-container gx-lg-8 gx-xl-12 gy-10 align-items-center mb-15 mb-md-17">
    <div class="col-lg-6 position-relative">
    <div class="position-absolute d-none d-md-block" style="top: 50%; left: 50%; width: 130%; height: auto; transform: translate(-50%,-50%); z-index:-1"><img class="w-100" alt="blurryImage"></div>

    <div class="row gx-md-5 gy-5" *ngIf="shortTestimonials?.length">
        <div *ngFor="let testimonial of shortTestimonials.slice(0, 3); let i = index"
             [ngClass]="{
                'col-md-6 col-xl-5 align-self-end': i === 2,
                'col-md-6 align-self-end': i === 3,
                'col-md-6 col-xl-5 offset-xl-1': i === 1,
                'col-md-6 align-self-start': i === 0
             }">
          <div class="card shadow-xl rounded-xl">
            <div class="card-body">
              <blockquote class="icon mb-0">
                <p>“{{testimonial.description}}”</p>
                <div class="blockquote-details">
                  <div class="info p-0">
                    <h4 class="mb-1">{{testimonial.name}}</h4>
                    <p class="mb-0">{{testimonial.position}}</p>
                  </div>
                </div>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-5">
        <h2 class="default-pattern-color display-2 mb-2 mt-lg-n6">{{ourTeamData?.testimonials.title}}</h2>
        <p class="lead fs-lg mb-4" [innerHTML]="ourTeamData?.testimonials.description"></p>
        <a *ngIf="screenWidth > 1024" routerLink="/testimonials" class="btn btn-primary rounded-xl mt-3">{{'landing.all_testimonials' | translateWithKeys}}</a>
    </div>

</div>
<div class="margin-top-25">
  <a *ngIf="screenWidth < 1024" routerLink="/testimonials" class="btn btn-primary rounded-xl mt-3">{{'landing.all_testimonials' | translateWithKeys}}</a>
</div>
